import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import './index.css';
import 'react-toastify/dist/ReactToastify.css'; // Add this line!
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 
import { toast } from 'react-toastify';
import App from './App';


const root = createRoot(document.getElementById('root'));

window.alert = (message) => {
  // If the message contains 'error' or 'fail', show an error toast
  if (message.toLowerCase().includes('error') || message.toLowerCase().includes('fail')) {
    toast.error(message);
  } else {
    // Otherwise, show a nice blue success toast
    toast.info(message);
  }
};

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}